// @ts-nocheck
goog.declareModuleId('yext.ui.components.deprecated.DEPRECATED_DatePicker');

goog.require('yext.ui.components.i18n');

goog.require('goog.date.Date');
import DateRange from 'goog:goog.date.DateRange';
import DateTimeFormat from 'goog:goog.i18n.DateTimeFormat';
import DateTimeParse from 'goog:goog.i18n.DateTimeParse';
import InputDatePicker from 'goog:goog.ui.InputDatePicker';

import {yext} from '/ui/lib/msg';

const DATE_FORMAT = 'yyyy-MM-dd';
const DISPLAY_FORMAT = DateTimeFormat.Format.SHORT_DATE;

/**
 * @typedef {!{
 *   ariaLabel?: string,
 *   date?: (Date|string|null),
 *   min?: (Date|string|null),
 *   max?: (Date|string|null),
 *   onChange: (function((string|null|undefined)):void),
 *   startAutoFocus?: boolean,
 *   width?: string,
 * }}
 */
let DatePickerProps;

export class DEPRECATED_DatePicker extends React.Component {
  /** @param {DatePickerProps} props */
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();
    this.popupRef = React.createRef();
    this.parser = new DateTimeParse(DATE_FORMAT);
    this.displayParser = new DateTimeParse(DISPLAY_FORMAT);
    this.inputDatePicker = new InputDatePicker(
      new DateTimeFormat(DISPLAY_FORMAT),
      this.displayParser,
    );

    const dp = this.inputDatePicker.getDatePicker();

    dp.setShowFixedNumWeeks(false);
    dp.setShowOtherMonths(false);
    dp.setExtraWeekAtEnd(false);
    dp.setShowWeekNum(false);
    dp.setShowWeekdayNames(true);
    dp.setAllowNone(false);
    dp.setShowToday(false);
    dp.setUseNarrowWeekdayNames(false);
    dp.setUseSimpleNavigationMenu(false);
    dp.setLongDateFormat(false);

    this.setDateRange(this.props.min, this.props.max);
    this.setDate(this.props.date);
  }

  parseDateIfString(date) {
    if (typeof date === 'string') {
      const newDate = new goog.date.Date();
      if (this.parser.parse(date, newDate) > 0) {
        return newDate;
      } else {
        return null;
      }
    } else {
      return date;
    }
  }

  setDate(date) {
    if (date) {
      const newDate = this.parseDateIfString(date);
      this.inputDatePicker.setDate(newDate);
    } else {
      this.inputDatePicker.setDate(null);
    }
  }

  setDateRange(min, max) {
    const dp = this.inputDatePicker.getDatePicker();

    let start = DateRange.MINIMUM_DATE;
    if (min) {
      start = this.parseDateIfString(min);
    }

    let end = DateRange.MAXIMUM_DATE;
    if (max) {
      end = this.parseDateIfString(max);
    }

    dp.setUserSelectableDateRange(
      new DateRange(start, end),
    );
  }

  applyDateRange(dateRange, date) {
    const startDate = dateRange.getStartDate();
    const endDate = dateRange.getEndDate();
    let newDate = date;
    if (date < startDate) {
      newDate = new goog.date.Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate());
    } else if (date > endDate) {
      newDate = new goog.date.Date(
        endDate.getFullYear(),
        endDate.getMonth(),
        endDate.getDate());
    }
    return newDate;
  }

  componentDidMount() {
    this.inputDatePicker.setPopupParentElement(this.popupRef.current);
    this.inputDatePicker.decorate(this.containerRef.current);
    if (this.props.date) {
      this.setDate(this.props.date);
    }

    // Force datePicker to trigger change when input element changes
    this.inputDatePicker.getElement().addEventListener('change', e => {
      const value = this.inputDatePicker.getInputValue().trim();
      if (!value) {
        this.inputDatePicker.getPopupDatePicker().setDate(null);
      } else {
        const date = new goog.date.Date();
        if (this.displayParser.parse(value, date, {validate: true}) > 0) {
          this.inputDatePicker.getPopupDatePicker().setDate(
            this.applyDateRange(
              this.inputDatePicker.getDatePicker().getUserSelectableDateRange(),
              date));
        }
      }
    });

    this.inputDatePicker.listen('change', e => {
      let newDate = e.date;
      const datePicker = this.inputDatePicker.getDatePicker();
      const dateRange = datePicker.getUserSelectableDateRange();
      if (newDate) {
        newDate = this.applyDateRange(dateRange, newDate);
        const oldDate = this.parseDateIfString(this.props.date);
        if (!oldDate || oldDate.getTime() !== newDate.getTime()) {
          // split to get rid the time from the DateTime
          const update = newDate.toIsoString(true, false).split('T')[0].trim();
          this.props.onChange(update);
        }
      } else {
        this.setDate(null);
        if (this.props.date) {
          this.props.onChange();
        }
      }
    });

    if (this.props.startAutoFocus) {
      this.inputDatePicker.getElement().focus();
    }

    labelPaginationButtons(this.inputDatePicker.getDatePicker());
  }

  componentDidUpdate(prevProps) {
    if (this.props.min !== prevProps.min || this.props.max !== prevProps.max) {
      this.setDateRange(this.props.min, this.props.max);
    }

    const visible = this.inputDatePicker.getPopupDatePicker().isVisible();
    const oldDate = this.parseDateIfString(prevProps.date);
    const newDate = this.parseDateIfString(this.props.date);
    if (!oldDate && newDate) {
      this.setDate(newDate);
    }
    if (oldDate && !newDate) {
      this.setDate(newDate);
    }
    if (oldDate && newDate && oldDate.getTime() !== newDate.getTime()) {
      this.setDate(newDate);
    }
    if (visible) {
      this.inputDatePicker.showForElement(this.containerRef.current);
    }
  }

  componentWillUnmount() {
    this.inputDatePicker.dispose();
  }

  render() {
    return (
      <span
        className="yext-date-picker"
        role="presentation"
        onFocus={e => {
          // e.relatedTarget is null when selecting the month or year dropdowns
          if (e.relatedTarget !== null && !e.currentTarget.contains(e.relatedTarget)) {
            this.inputDatePicker.showForElement(this.containerRef.current);
          }
        }}
        onBlur={e => {
          // e.relatedTarget is null when selecting the month or year dropdowns
          if (e.relatedTarget !== null && !e.currentTarget.contains(e.relatedTarget)) {
            this.inputDatePicker.hidePopup();
          }
        }}
        onKeyDown={({key}) => {
          if (key === 'Escape') {
            this.inputDatePicker.hidePopup();
          }
        }}
      >
        <input
          aria-label={this.props.ariaLabel}
          ref={this.containerRef}
          style={{width: this.props.width}}
        />
        <div ref={this.popupRef} />
      </span>
    );
  }
}

/**
 * @param {goog.ui.DatePicker} dp
 */
function labelPaginationButtons(dp) {
  const setLabel = (className, label) => {
    dp.getElementByClass(className).setAttribute('aria-label', label);
  };
  setLabel(goog.getCssName(dp.getBaseCssClass(), 'previousMonth'), yext.msg('Previous Month'));
  setLabel(goog.getCssName(dp.getBaseCssClass(), 'nextMonth'), yext.msg('Next Month'));
  setLabel(goog.getCssName(dp.getBaseCssClass(), 'previousYear'), yext.msg('Previous Year'));
  setLabel(goog.getCssName(dp.getBaseCssClass(), 'nextYear'), yext.msg('Next Year'));
}
